/**
 * How loud each kind of sound is (0–1, on top of the volume): the aircraft (engines, helicopters,
 * display jets), the world around (wind, rain, birds, crickets, terminals, thunder, fireworks)
 * and the interface (clicks, chimes, the radio's squelch). Kept apart from sound.ts so the
 * preferences can name it without starting the audio.
 */
export interface SoundMix {
  engines: number;
  world: number;
  interface: number;
}

export const DEFAULT_SOUND_MIX: SoundMix = { engines: 1, world: 1, interface: 1 };
